module.exports = __webpack_public_path__ + "img/sbtn1.4af8b091.png";